module.exports = "/_next/static/images/bulb-3ecabb6133b72e6fe880d2892bcceacb.png";